import styled from 'styled-components'
import { H5 } from '../../../../../../../../../../Styles/typography'
import { accent } from '../../../../../../../../../../Styles/colors'
import { vFlex } from '../../../../../../../../../../Styles/style-helpers'

export const SubmissionsEl = styled.div`
  position: relative;
  right: 0;
  top: 0;
  width: 27.5em;
  height: calc(100% - 4em);
  background: #232323;
  margin: 2em;
  border-radius: 1em;
  padding: 1em;
  color: white;
  ${vFlex};
  justify-content: flex-start;

  & > ${H5} {
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 1em 0;
    width: 100%;
    text-align: center;
  }

  .separator {
    display: block;
    width: 5em;
    height: 1px;
    background: ${accent};
    margin: 1em auto 0;
  }

  .chapters {
    display: block;
    height: 100%;
    flex: 1;
    overflow: auto;
    width: 100%;
    position: relative;

    &:after {
      content: '';
      width: 100%;
      height: 5em;
      position: absolute;
      bottom: 0;
      background: linear-gradient(
        to bottom,
        rgba(35, 35, 35, 0),
        rgba(35, 35, 35, 1) 75%,
        rgba(35, 35, 35, 1)
      );
    }

    .padding {
      height: 5em;
    }
  }
`
